"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchHandler = void 0;
var tslib_1 = require("tslib");
var manipulator_handler_base_1 = require("../base/manipulator-handler-base");
var touch_handler_default_state_1 = require("./touch-handler-default-state");
var TouchHandler = (function (_super) {
    tslib_1.__extends(TouchHandler, _super);
    function TouchHandler(control, boxVisualizerManager) {
        return _super.call(this, control, touch_handler_default_state_1.TouchHandlerDefaultState, boxVisualizerManager) || this;
    }
    TouchHandler.prototype.onTouchStart = function (evt) {
        this.state.onTouchStart(evt);
    };
    TouchHandler.prototype.onDoubleTap = function (evt) {
        this.state.onDoubleTap(evt);
    };
    TouchHandler.prototype.onTouchEnd = function (evt) {
        this.state.onTouchEnd(evt);
    };
    TouchHandler.prototype.onTouchMove = function (evt) {
        return this.state.onTouchMove(evt);
    };
    TouchHandler.prototype.onGestureStart = function (_evt) {
        this.switchToDefaultState();
    };
    return TouchHandler;
}(manipulator_handler_base_1.ManipulatorHandlerBase));
exports.TouchHandler = TouchHandler;
